import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EditorComponent } from '@progress/kendo-angular-editor';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { urlValidator } from '@app/shared/utils/validators';

@Component({
  standalone: false,
  selector: 'ti-insert-link-modal',
  templateUrl: './insert-link-modal.component.html',
  styleUrls: ['./insert-link-modal.component.scss'],
})
export class InsertLinkModalComponent implements OnInit {
  readonly miscStrings = tiStrings.app.misc;
  readonly strings = tiStrings.modules.quality.incidents;
  form: FormGroup;

  @Input() editor: EditorComponent;
  @Output() close$ = new EventEmitter<boolean>();

  ngOnInit(): void {
    this.form = new FormGroup({
      url: new FormControl('', [Validators.required, urlValidator]),
      title: new FormControl('', Validators.required),
      openInNewWindow: new FormControl(true),
    });
  }

  insertLink(): void {
    if (this.isValid) {
      const { url, text, openInNewWindow } = this.form.value;
      const target = openInNewWindow ? '_blank' : '_self';
      this.editor.exec('createLink', { href: url, title: text, target });
      this.close();
    }
  }

  close(): void {
    this.close$.emit(false);
  }

  get isValid(): boolean {
    return this.form.valid;
  }

  getError(controlName: string): string | null {
    const control: AbstractControl = this.form.get(controlName);
    if (control && control.invalid && control.touched) {
      const { errors } = control;
      if (errors?.required) {
        return this.miscStrings.thisFieldIsRequired;
      }
      if (errors?.notUrl) {
        return this.strings.notValidURL;
      }
    }
    return null;
  }
}
